// DS-1.3: Sentry privacy options for the browser and the node server. Pure
// (no imports) so it can be unit-tested.
export const REPLAY_OPTIONS = {maskAllText: true, blockAllMedia: true};

// Replays only on draksy.com itself; visitors of customers' sites are never replayed.
export function replayRates(hostname) {
    const on = hostname === 'draksy.com';
    return {replaysSessionSampleRate: on ? 1.0 : 0.0, replaysOnErrorSampleRate: on ? 1.0 : 0.0};
}

export const SERVER_SENTRY_OPTIONS = {sendDefaultPii: false, tracesSampleRate: 0.2};
